import React from "react";

const EntityDetailsPopup = ({ selectedEntity, onClose, onLoadConnections }) => {
  if (!selectedEntity) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/50 md:items-center">
      <div className="max-h-[85dvh] w-full max-w-md overflow-y-auto rounded-t-2xl bg-gray-800 p-6 pb-[max(1.5rem,env(safe-area-inset-bottom))] shadow-2xl md:mx-4 md:max-h-96 md:rounded-lg md:pb-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-xl font-bold text-white">Entity Details</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors"
            aria-label="Close popup"
          >
            ✕
          </button>
        </div>

        <div className="space-y-3">
          <div>
            <label className="text-sm font-medium text-gray-300">Name</label>
            <div className="text-white">
              {selectedEntity.name || selectedEntity.data?.label || "Unknown"}
            </div>
          </div>

          <div>
            <label className="text-sm font-medium text-gray-300">Type</label>
            <div className="text-white">
              {selectedEntity.type ||
                selectedEntity.data?.entityType ||
                "Unknown"}
            </div>
          </div>

          {selectedEntity.description && (
            <div>
              <label className="text-sm font-medium text-gray-300">
                Description
              </label>
              <div className="text-white text-sm">
                {selectedEntity.description}
              </div>
            </div>
          )}
        </div>

        <div className="mt-6 flex justify-between">
          <button
            onClick={() => {
              onLoadConnections(selectedEntity);
              onClose();
            }}
            className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition-colors"
          >
            🔗 Load Connections
          </button>
          <button
            onClick={onClose}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default EntityDetailsPopup;
